module.exports = __webpack_public_path__ + "img/5.c016ede0.jpg";